import { MigrateFunctionBuilder } from '@salsita-ai/platform-project-sdk/domain';
import { modelVersion, modelVersions } from '../__generated/model/index.js';
export const migrations = {};
export const migrate = MigrateFunctionBuilder.fromVersions(modelVersions).to(modelVersion).using(migrations).build();

//# sourceMappingURL=index.js.map